import { GenericDialog } from "@/components/dialogs";
import { useState } from "react";
import { WelderPrintOptions } from "@/api/williams/report";

export type PrintDialogProps = {
  onAccept: (options: WelderPrintOptions) => void;
};

export function PrintDialog({ onAccept }: PrintDialogProps) {
  const [options, setOptions] = useState<WelderPrintOptions>({
    summary: false,
    certifications: false,
    welderRenewalLog: false,
    expirations: false,
  });

  function handleSelectionChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setOptions((prev) => ({
      ...prev,
      [e.target.id]: e.target.checked,
    }));
  }

  return (
    <GenericDialog
      caption="Select items to print"
      buttons="OKCancel"
      onAccept={() => onAccept(options)}
      allowAccept={Object.entries(options).some(([, value]) => value)}
    >
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="summary"
          checked={options.summary}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="summary">
          Summary of Welder Certifications
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="certifications"
          checked={options.certifications}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="certifications">
          Welder Certifications
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="welderRenewalLog"
          checked={options.welderRenewalLog}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="welderRenewalLog">
          Welder Certification and Renewal Log
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="expirations"
          checked={options.expirations}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="expirations">
          Welder Expirations
        </label>
      </div>
    </GenericDialog>
  );
}
